import gql from 'graphql-tag';

const GET_ALL = gql`
  query All($perPage: Int!, $page: Int, $where: BidangWhereWhereConditions) {
    bidang(first: $perPage, page: $page, where: $where) {
      data {
        id
        nama
        uuid
        instansi{
          nama
          alias
        }
      }
      paginatorInfo {
        count
        total
        hasMorePages
        currentPage
        lastPage
        perPage
      }
    }
  }
`;

const GET_DETAIL = gql`
  query find($id: String!){
    bidangByUuid(uuid: $id){
      id
      nama
      uuid
      instansi_id
      instansi{
        nama
        alias
      }
    }
  }
`;

const CREATE = gql `
    mutation($input:BidangCreateInput!){
        bidangCreate(input:$input){
            id,
            uuid,
            nama
        }
    }
`

const UPDATE = gql `
    mutation($id: ID!, $input:BidangUpdateInput!){
        bidangUpdate(id:$id, input:$input){
            id
            uuid
            nama
        }
    }
`

const DELETE = gql `
  mutation bidangDelete($id: ID!){
    bidangDelete(id: $id){
      uuid
    }
  }
`

export { GET_ALL, GET_DETAIL, CREATE, UPDATE, DELETE};
